import {$clientApi} from "../http";
import {IPublicTrainingCourse} from "../models/TrainingCourse";
import {IClass} from "../models/ClassEventReservation";

class ClassesServiceClass {

    async getClasses() {
        return $clientApi.get<IPublicTrainingCourse[]>(`api/public/training-courses`)
    }

    async getClassById(id: number) {
        return $clientApi.get<IClass>(`api/trainning-courses/${id}`);
    }

    async getSubscriptionForAppointment(model: {courseId: number, customerId: number}) {
        return $clientApi.post<any>(`api/appointments/get-class-subscription`, model);
    }

}

export const ClassesService = new ClassesServiceClass()